import { AreaDetailTabs } from "./AreaDetailTabs";
import React from "react";
import { AreaDetailRoutes } from "../Routes";
import { useParams } from "react-router-dom";
import { AreaDetailHeader } from "./AreaDetailHeader";

export const AreaDetailLayout = () => {
  const { area_id } = useParams();

  return (
    <div>
      <AreaDetailHeader area_id={area_id} />
      <AreaDetailTabs />
      <AreaDetailRoutes area_id={area_id} />
    </div>
  );
};
